import classnames from 'classnames';
import * as React from 'react';
import { TabType } from '../App';

export type ParentTabProps = {
  activeTab: TabType;
  onSelect: (id: TabType) => void;
};

export type TabProps = {
  badge?: React.ReactElement | false;
  cssClass?: string;
  icon: React.ReactElement;
  id: TabType;
  activeTab: TabType;
  name: string;
  onClick: (id: TabType) => void;
};

export const Tab = (props: TabProps) => {
  const { icon, cssClass, badge } = props;

  const isActive = () => props.activeTab === props.id;
  const handleClick = (e: React.MouseEvent) => {
    const { onClick, id } = props;
    e.preventDefault();
    onClick(id);
  };

  return (
    <li className={classnames('tab', { active: isActive() }, cssClass)}>
      <div className="badge">{badge}</div>
      <a href="#" onClick={handleClick}>
        <span className="icon">{icon}</span>
      </a>
    </li>
  );
};
